<template>
  <div class="layout">
    <Menu mode="horizontal" theme="dark" active-name="1" @on-select="selected">
      <div class="layout-logo"><img src="../assets/images/logo.png" alt=""></div>
      <div class="layout-nav">
        <Menu-item name="1">
          <Icon type="ios-home"></Icon>
          首页
        </Menu-item>
        <Menu-item name="2">
          <Icon type="ios-paper"></Icon>
          需求管理
        </Menu-item>
        <Menu-item name="3">
          <Icon type="ios-keypad"></Icon>
          产品管理
        </Menu-item>
        <Menu-item name="4">
          <Icon type="person"></Icon>
          人员管理
        </Menu-item>
        <Menu-item name="5">
          <Icon type="person-stalker"></Icon>
          角色管理
        </Menu-item>
        <Submenu name="6" style="float:right;">
          <template slot="title">
            <Icon type="ios-gear"></Icon>
            设置
          </template>
          <Menu-item name="61">修改密码</Menu-item>
          <Menu-item name="62">退出</Menu-item>
        </Submenu>
        <div class="user-name-bar">{{ userName }}({{ userTrueName }})</div>
      </div>
    </Menu>
     <div class="content">
       <router-view></router-view>
     </div>
    <footer class="layout-copy">2011-2016 &copy; 艾润物联</footer>
  </div>
</template>

<script>
  export default {
    created:function(){

    },
    data () {
      return {
        //用户信息
        userName:'admin',
        userTrueName:'丁东阳'
      }
    },
    methods: {
      selected (name) {
        var routers = []
        routers[1] ='Requirement'
        routers[2] ='Production'
        routers[62] ='Login'
        if(name == 1){
          this.index = true
        }else{
          this.index = false
        }
        this.$router.push({'name':routers[name]})
      }
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// Layout.vue?5d2bfb4b